import uniq from 'lodash-es/uniq';
import { tupdate } from 'mk2/helpers/types';
import infiniteList, {
    initialState as infiniteInitialState,
    State as InfiniteListState,
} from 'mk2/reducers/infiniteList';
import { Reducer } from 'redux';
import {
    ForumTopicsFetchFailureAction,
    ForumTopicsFetchRequestAction,
    ForumTopicsFetchSuccessAction,
    ForumTopicsUpdateSearchAction,
    FORUM_TOPICS_FETCH_FAILURE,
    FORUM_TOPICS_FETCH_REQUEST,
    FORUM_TOPICS_FETCH_SUCCESS,
    FORUM_TOPICS_UPDATE_SEARCH,
} from './ForumTopics.actions';

export interface SearchState extends InfiniteListState {
    followingIds: number[];
}

type SearchReducerAction =
    ForumTopicsFetchRequestAction
    | ForumTopicsFetchSuccessAction
    | ForumTopicsFetchFailureAction;

export const initialSearchState: SearchState = {
    ...infiniteInitialState,
    followingIds: [],
};

const searchReducer: Reducer<SearchState> = (state: SearchState = initialSearchState, action: SearchReducerAction) => {
    const newState: SearchState = {
        ...state,
        ...infiniteList<ForumTopicsFetchRequestAction, ForumTopicsFetchSuccessAction, ForumTopicsFetchFailureAction>(
            'FORUM_TOPICS_FETCH',
            (a) => a.response.result.topics,
        )(state, action),
    };

    switch (action.type) {
        case FORUM_TOPICS_FETCH_SUCCESS:
            newState.followingIds = uniq(action.response.result.followingTopics);
            break;
    }

    return newState;
};

interface CategoryState {
    [search: string]: SearchState;
}

type CategoryReducerAction =
    ForumTopicsFetchRequestAction
    | ForumTopicsFetchSuccessAction
    | ForumTopicsFetchFailureAction;

const categoryReducer: Reducer<CategoryState> = (state: CategoryState = {}, action: CategoryReducerAction) => {
    switch (action.type) {
        case FORUM_TOPICS_FETCH_REQUEST:
        case FORUM_TOPICS_FETCH_SUCCESS:
        case FORUM_TOPICS_FETCH_FAILURE:
            const search = action.search;

            return tupdate(state, {
                [search]: searchReducer(state[search], action),
            });
        default:
            return state;
    }
};

interface CategoriesState {
    [categorySlug: string]: CategoryState;
}

type CategoriesReducerAction =
    ForumTopicsFetchRequestAction
    | ForumTopicsFetchSuccessAction
    | ForumTopicsFetchFailureAction;

const categoriesReducer: Reducer<CategoriesState> = (state: CategoriesState = {}, action: CategoriesReducerAction) => {
    switch (action.type) {
        case FORUM_TOPICS_FETCH_REQUEST:
        case FORUM_TOPICS_FETCH_SUCCESS:
        case FORUM_TOPICS_FETCH_FAILURE:
            const categorySlug = action.categorySlug;
            return tupdate(state, {
                [categorySlug]: categoryReducer(state[categorySlug], action),
            });
        default:
            return state;
    }
};

export interface ForumTopicsPageState {
    categories: CategoriesState;
    search: string;
}

export const initialForumTopicsPageState: ForumTopicsPageState = {
    categories: {},
    search: '',
};

type ForumTopicsPageReducerAction =
    ForumTopicsFetchRequestAction
    | ForumTopicsFetchSuccessAction
    | ForumTopicsFetchFailureAction
    | ForumTopicsUpdateSearchAction;

const forumTopicsPageReducer: Reducer<ForumTopicsPageState> =
    (state: ForumTopicsPageState = initialForumTopicsPageState, action: ForumTopicsPageReducerAction) => {

    switch (action.type) {
        case FORUM_TOPICS_FETCH_REQUEST:
        case FORUM_TOPICS_FETCH_SUCCESS:
        case FORUM_TOPICS_FETCH_FAILURE:
            return tupdate(state, {
                categories: categoriesReducer(state.categories, action),
            });
        case FORUM_TOPICS_UPDATE_SEARCH:
            return tupdate(state, {
                search: action.search,
            });
        default:
            return state;
    }
};

export default forumTopicsPageReducer;
